'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _FormField = require('./FormField');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var reduxFormFieldProps = function reduxFormFieldProps(field) {
  if (!field) {
    return {};
  }

  var validate = field.validate,
      format = field.format,
      normalize = field.normalize,
      parse = field.parse,
      warn = field.warn;


  return {
    validate: validate,
    format: format,
    normalize: normalize,
    parse: parse,
    warn: warn
  };
};

function renderField(props) {
  var renderInput = props.renderInput,
      fieldProps = _objectWithoutProperties(props, ['renderInput']);

  var fieldType = props.type || fieldProps.field && fieldProps.field.type;

  if (fieldType === "fieldarray") {}

  return renderInput(fieldType || "text")(props);
}

var FieldValue = function (_Component) {
  _inherits(FieldValue, _Component);

  function FieldValue() {
    _classCallCheck(this, FieldValue);

    return _possibleConstructorReturn(this, (FieldValue.__proto__ || Object.getPrototypeOf(FieldValue)).apply(this, arguments));
  }

  _createClass(FieldValue, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var context = this.context;

      var field = (0, _FormField.getField)(context.fields, props.name || context.name);
      var value = context.values && (0, _FormField.getField)(context.values, props.name || context.name, context.namePrefix);

      var _props = this.props,
          validate = _props.validate,
          type = _props.type,
          autoFocus = _props.autoFocus,
          onChange = _props.onChange,
          onBlur = _props.onBlur;


      var drillProps = {
        autoFocus: autoFocus, onChange: onChange, onBlur: onBlur
      };

      if (validate) {
        drillProps.validate = validate;
      }
      if (type) {
        drillProps.type = type;
      }

      if (context.mode === 'display' && ["display", "value"].includes(props.mode) || props.mode === "display" || props.displayOnly || props.mode === "value") {
        // TODO: Use values from redux-form rather
        var DisplayField = props.renderField || (props.renderDisplay ? props.renderDisplay(props.type || field.type) : context.renderDisplay(props.type || field.type));
        if (context.mode === "display" && ["display", "value"].includes(props.mode)) {
          return _react2.default.createElement(DisplayField, _extends({}, props, { field: field, value: value }));
        }
        return _react2.default.createElement(_reduxForm.Field, _extends({
          component: DisplayField,
          field: field
        }, reduxFormFieldProps(field), drillProps, props, {
          name: context.namePrefix ? context.namePrefix + '.' + (props.name || context.name) : props.name || context.name
        }));
      } else {
        return _react2.default.createElement(_reduxForm.Field, _extends({
          component: renderField,
          field: field
        }, reduxFormFieldProps(field), drillProps, props, {
          name: context.namePrefix ? context.namePrefix + '.' + (props.name || context.name) : props.name || context.name,
          renderInput: props.renderField ? function () {
            return props.renderField;
          } : props.renderInput || context.renderInput
        }));
      }
    }
  }]);

  return FieldValue;
}(_react.Component);

FieldValue.propsTypes = {
  display: _propTypes2.default.bool
};

FieldValue.contextTypes = {
  fields: _propTypes2.default.object,
  mode: _propTypes2.default.string,
  name: _propTypes2.default.string,
  renderInput: _propTypes2.default.func,
  renderDisplay: _propTypes2.default.func,
  values: _propTypes2.default.object,
  namePrefix: _propTypes2.default.string
};

exports.default = FieldValue;